import React from 'react';

const Contact = () => (
  <section id="contact" className="py-5 bg-white">
    <div className="container">
      <h2 className="text-center mb-4">Contact Us</h2>

      <div className="row">
        {/* Contact Info */}
        <div className="col-md-5 mb-4">
          <h5>Get in Touch</h5>
          <p><strong>Address:</strong> H-89  Rajveer Coloney ,Semra road Bhopal</p>
          <p><strong>Email:</strong> pradeep.kumar.ahirwar@gmail.com</p>
          <p><strong>Phone:</strong> +91 9981914799</p>

          <div className="mt-3">
            <a href="#" className="me-3"><i className="bi bi-facebook"></i> Facebook</a>
            <a href="#"><i className="bi bi-instagram"></i> Instagram</a>
          </div>
        </div>

        {/* Contact Form */}
        <div className="col-md-7">
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <input type="text" className="form-control" placeholder="Your Name" required />
              </div>
              <div className="col-md-6 mb-3">
                <input type="email" className="form-control" placeholder="Email Address" required />
              </div>
            </div>
            <div className="mb-3">
              <input type="text" className="form-control" placeholder="Subject" />
            </div>
            <div className="mb-3">
              <textarea className="form-control" rows="5" placeholder="Your Message" required></textarea>
            </div>
            <button type="submit" className="btn btn-primary">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
